import { useEffect } from "react";
import { Auth } from "aws-amplify";
import { saveLogin } from "./utils";

const SkeletonAgentHome = () => {
    const headerH = 64;
    const headerStyle = { height: headerH, background: '#ffffff', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', padding: '0 20px' };
    const pageBg = { background: '#e9f6f4', minHeight: `calc(100vh - ${headerH}px)`, padding: 24 };
    const leftCard = { width: 140, height: 140, background: '#ffffff', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };
    const rightPanel = { width: 600, height: '70vh', background: '#ffffff', borderRadius: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', padding: 12 };

    return (
        <div>
            <div style={headerStyle}>
            </div>

            <div style={pageBg}>
                <div style={{ display: 'flex', gap: 24 }}>
                    <div style={{ width: 180 }}>
                        <div style={leftCard}>
                        </div>
                    </div>

                    <div style={{ flex: 1, minHeight: 400 }}>
                        <div style={{ background: 'transparent', minHeight: 400 }}></div>
                    </div>

                    <div style={{ flex: 1, width: 360, marginLeft: 400 }}>
                        <div style={rightPanel}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error('Error decoding token:', e);
        return {};
    }
};

const SSOLogin = (props) => {
    const processSSOToken = async () => {
        const token = new URLSearchParams(window.location.search).get("token");
        if (!token) {
            props.history.push("/login");
            return;
        }

        try {
            try {
                const decoded = decodeToken(token);
                if (decoded && decoded.iss && typeof decoded.iss === 'string') {
                    const expectedPool = process.env.REACT_APP_AGENT_USER_POOL;
                    const expectedIssuer = `https://cognito-idp.us-east-2.amazonaws.com/${expectedPool}`;
                    if (expectedPool && decoded.iss !== expectedIssuer) {
                        console.warn('SSO token issuer mismatch', { tokenIss: decoded.iss, expectedIssuer });
                    }
                }
            } catch (e) {
            }

            await Auth.federatedSignIn(
                `cognito-idp.us-east-2.amazonaws.com/${process.env.REACT_APP_AGENT_USER_POOL}`,
                { token, expires_at: Date.now() + 3600 * 1000 },
                null
            );
            try {
                sessionStorage.setItem('sso_token', token);
                sessionStorage.setItem('switchToken', token);
            } catch (e) {
                console.warn('Unable to persist sso_token to sessionStorage', e);
            }
            const decodedToken = decodeToken(token);
            const email = decodedToken.email || decodedToken['cognito:username'] || '';
            localStorage.setItem("isLogged", "true");
            saveLogin(email);
            localStorage.setItem("IAgree", "true");
            window.history.replaceState({}, document.title, "/");
            props.history.push("/");
        } catch (err) {
            console.error("SSO failed", err);
            props.history.push("/login");
        }
    };

    useEffect(() => { processSSOToken(); }, []);

    return <SkeletonAgentHome />;
};

export default SSOLogin;
